import { render, staticRenderFns } from "./DepartmentHeadsDialog.vue?vue&type=template&id=3acadf17&scoped=true"
import script from "./DepartmentHeadsDialog.vue?vue&type=script&lang=js"
export * from "./DepartmentHeadsDialog.vue?vue&type=script&lang=js"
import style0 from "./DepartmentHeadsDialog.vue?vue&type=style&index=0&id=3acadf17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acadf17",
  null
  
)

export default component.exports